import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Modal from "../../../components/Modal/Modal";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import { injectModels } from "../../../redux/injectModels";
import ImagePreview from "../../../components/Image/ImagePreview";
import ImageUpload from "../../../components/Image/ImageUploadWithDefaultSize";
import { routes } from "../../../constants/routes";
import { getStateList } from "../../../services/StateService";
import { getCountryList } from "../../../services/CountryService";
import traderUnitModel from "../../../components/Model/TraderUnitModel";
import { TraderUnitService, AuthService } from "../../../services";
import { handleConsoleError } from "../../../utils/common-methods";

const CreateTraderUnit = (props) => {
  const { unitId } = useParams();
  const [isModalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  const [stateList, setStateList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [previewImageURL, setPreviewImageURL] = useState("");
  const [traderUnitData, setTraderUnitData] = useState({ ...traderUnitModel });
  const loginUser = AuthService.getLoginUser();

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const maxDate = new Date().toISOString().split("T")[0];
  //const minDate = new Date().toISOString().split("T")[0];
  const openCoverModal = () => {
    setPreviewImageURL(traderUnitData?.imageUrl);
    openModal();
  };

  // const setSelectedCountry = (value) => {
  //   if (value) {
  //     setSelectedCountryId(value);
  //   } else {
  //     setSelectedCountryId("");
  //     setSelectedStateId("");
  //   }
  // };
  // const setSelectedState = (value) => {
  //   if (value) {
  //     setSelectedStateId(value);
  //   } else {
  //     setSelectedStateId("");
  //   }
  // };

  const handleBackButton = (e) => {
    e.preventDefault();
    navigate(routes.TRADER_UNIT_LIST);
  };
  const handleImageUpload = async (file) => {
    props.application.setLoading(true);

    const formData = new FormData();
    formData.append("Image", file.get("image"));
    if (unitId) {
      formData.append("Id", unitId);
    }

    try {
      const response = await TraderUnitService.uploadTraderUnitImage(formData);
      if (response?.isSuccess) {
        props.application.setLoading(false);
        closeModal();
        reset({ ...traderUnitData, id: response?.data?.id });
        setPreviewImageURL(response?.data?.completeURL);
        toast.success(response?.message);
      } else {
        props.application.setLoading(false);
        toast.error(response?.message);
      }
    } catch (err) {
      props.application.setLoading(false);
      const message = handleConsoleError(err);
      toast.error(err?.message || message);
    }
  };

  const getData = async () => {
    props.application.setLoading(true);
    const stateList = await getStateList();
    const countryList = await getCountryList();
    setStateList(stateList.data || []);
    setCountryList(countryList.data || []);

    if (unitId) {
      try {
        const res = await TraderUnitService.getTraderUnitById(unitId);
        if (res?.isSuccess) {
          var traderUnitDataTemp = res?.data;
          setPreviewImageURL(res?.data?.imageUrl);

          if (traderUnitDataTemp?.countryId) {
            setSelectedCountryId(traderUnitDataTemp.countryId);
          }
          if (traderUnitDataTemp?.stateId) {
            setSelectedStateId(traderUnitDataTemp.stateId);
          }

          if (traderUnitDataTemp?.establishmentDate) {
            traderUnitDataTemp.establishmentDate = traderUnitDataTemp.establishmentDate?.split(
              "T"
            )[0];
          }

          reset(traderUnitDataTemp);
        } else {
          //toast.error(res?.message||res?.Errors?.[0]?.Message || "Something went wrong");
          reset(traderUnitModel);
        }
      } catch (error) {
        const message = handleConsoleError(error);
        toast.error(error?.message || message);
        props.application.setLoading(false);
      }
      props.application.setLoading(false);
    } else {
      setTraderUnitData({ ...traderUnitModel });

      props.application.setLoading(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      // You can await here
      await getData();

      // ...
    }
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    let updatedId = unitId || data?.id;
    try {
      const traderUnitData = {
        ...traderUnitModel,
        ...data,
        id: updatedId,
      };
      //TODO : Bug 7 
      // if(!traderUnitData.establishmentDate)
      // {
      //   traderUnitData.establishmentDate=null;
      // }

      const response = await TraderUnitService.updateTraderUnit(traderUnitData);
      if (response?.isSuccess) {
        navigate(routes.TRADER_UNIT_LIST);
        toast.success(response?.message);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };
  return (
    <React.Fragment>
      <section className="edit-form-table">
        <div className="container mt-3">
          <div>
            <section>
              <Modal isOpen={isModalOpen} onClose={closeModal}>
                <ImageUpload
                  imageURL={previewImageURL}
                  onUpload={handleImageUpload}
                  maxSize={4 * 1024 * 1024}
                  validTypes={["image/png", "image/gif", "image/jpeg"]}
                ></ImageUpload>
              </Modal>
              {/* <section className="subscription-banner p-0">
                <div className="container">
                  <h3>Add Unit</h3>
                </div>
              </section> */}

              <Form.Group controlId="userId">
                <Form.Control
                  type="hidden"
                  {...register("userId")}
                  value={loginUser?.id}
                />
              </Form.Group>

              <Form className="col-12 row" onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="col-6 mb-3">
                  <Form.Label>
                    Unit Name <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    maxLength={200}
                    type="text"
                    {...register("unitName", {
                      required: "Unit name is required",
                    })}
                    defaultValue={traderUnitData?.unitName}
                  />
                  {errors.unitName && (
                    <span className="text-danger">
                      {errors.unitName?.message}
                    </span>
                  )}
                </Form.Group>

                <Form.Group className="col-6 mb-3">
                  <Form.Label>
                    Business Type <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    maxLength={200}
                    type="text"
                    {...register("businessType", {
                      required: "Business Type is required",
                    })}
                    defaultValue={traderUnitData?.businessType}
                  />
                  {errors.businessType && (
                    <span className="text-danger">
                      {errors.businessType?.message}
                    </span>
                  )}
                </Form.Group>

                <Form.Group className="col-6 mb-3">
                  <Form.Label>
                    Establishment Date
                    {/* <span className="text-danger">*</span> */}
                  </Form.Label>
                  <Form.Control
                    type="date"
                    {...register("establishmentDate", {
                      // required: "Establishment date is required",
                    })}
                    // min={minDate || undefined}
                    max={maxDate || undefined}
                    defaultValue={traderUnitData?.establishmentDate}
                  />

                  {errors.establishmentDate && (
                    <span className="text-danger">
                      {errors.establishmentDate?.message}
                    </span>
                  )}
                </Form.Group>

                <Form.Group className="col-6 mb-3">
                  <Form.Label>
                    State <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    //as="select"
                    {...register("countryId", {
                      required: "State is required",
                    })}
                    value={selectedCountryId}
                    onChange={(e) => {
                      setSelectedCountryId(e.target.value);
                    }}
                    placeholder="Select"
                  >
                    <option value="">Select State</option>
                    {countryList.map((country) => {
                      return (
                        <option key={country?.id} value={country?.id}>
                          {country?.countryName}
                        </option>
                      );
                    })}
                  </Form.Select>
                  {errors.countryId && (
                    <span className="text-danger">
                      {errors.countryId?.message}
                    </span>
                  )}
                  {/* <Form.Control
                    maxLength={200}
                    type="text"
                    {...register("countryId", {
                      required: "Country is required",
                    })}
                  />
                  {errors.establishmentDate && (
                    <span className="text-danger">
                      {errors.establishmentDate.message}
                    </span>
                  )} */}
                </Form.Group>

                <Form.Group className="col-6 mb-3">
                  <Form.Label>
                    Country <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    // as="select"
                    {...register("stateId", {
                      required: "Country is required",
                    })}
                    value={selectedStateId}
                    onChange={(e) => {
                      setSelectedStateId(e.target.value);
                    }}
                  >
                    <option value="">Select Country</option>
                    {stateList.map((state) => {
                      return (
                        <option key={state?.id} value={state?.id}>{state?.stateName}</option>
                      );
                    })}
                  </Form.Select>
                  {errors.stateId && (
                    <span className="text-danger">
                      {errors.stateId?.message}
                    </span>
                  )}
                  {/* <Form.Control
                    maxLength={200}
                    type="text"
                    {...register("stateId", {
                      required: "State is required",
                    })}
                  />
                  {errors.stateId && (
                    <span className="text-danger">
                      {errors.stateId.message}
                    </span>
                  )} */}
                </Form.Group>

                <Form.Group className="col-6 mb-3">
                  <Form.Label>
                    Street
                    {/* <span className="text-danger">*</span> */}
                  </Form.Label>
                  <Form.Control
                    maxLength={200}
                    type="text"
                    {...register("street", {
                      // required: "Street is required",
                    })}
                    defaultValue={traderUnitData?.street}
                  />
                  {errors.street && (
                    <span className="text-danger">{errors.street?.message}</span>
                  )}
                </Form.Group>

                <Form.Group className="col-6 mb-3">
                  <Form.Label>
                    City
                    {/* <span className="text-danger">*</span> */}
                  </Form.Label>
                  <Form.Control
                    maxLength={200}
                    type="text"
                    {...register("city", {
                      // required: "City is required",
                    })}
                    defaultValue={traderUnitData?.city}
                  />
                  {errors.city && (
                    <span className="text-danger">{errors.city?.message}</span>
                  )}
                </Form.Group>

                <Form.Group className="col-6 mb-3">
                  <Form.Label>
                    Zip Code <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    maxLength={200}
                    type="text"
                    {...register("zipCode", {
                      required: "Zip code is required",
                    })}
                    defaultValue={traderUnitData?.zipCode}
                  />
                  {errors.zipCode && (
                    <span className="text-danger">
                      {errors.zipCode?.message}
                    </span>
                  )}
                </Form.Group>

                <Form.Group className="col-6 mb-3">
                  <Form.Label>
                    Email <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    maxLength={200}
                    type="text"
                    {...register("email", {
                      required: "Email is required",
                    })}
                    defaultValue={traderUnitData?.email}
                  />
                  {errors.email && (
                    <span className="text-danger">{errors.email?.message}</span>
                  )}
                </Form.Group>

                <Form.Group className="col-6 mb-3">
                  <Form.Label>
                    Contact Number <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    maxLength={200}
                    type="text"
                    {...register("contactNumber", {
                      required: "Contact Number is required",
                    })}
                    defaultValue={traderUnitData?.contactNumber}
                  />
                  {errors.contactNumber && (
                    <span className="text-danger">
                      {errors.contactNumber?.message}
                    </span>
                  )}
                </Form.Group>

                <Form.Group className="col-6 mb-3">
                  <Form.Label>
                    Contact Person <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    maxLength={200}
                    type="text"
                    {...register("contactPerson", {
                      required: "Contact Person is required",
                    })}
                    defaultValue={traderUnitData?.contactPerson}
                  />
                  {errors.contactPerson && (
                    <span className="text-danger">
                      {errors.contactPerson?.message}
                    </span>
                  )}
                </Form.Group>

                {/* <Form.Group className="col-6 mb-3">
                  <Form.Label>
                    Unit Image <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    maxLength={200}
                    type="text"
                    {...register("unitImage", {
                      required: "unitImage is required",
                    })}
                  />
                  {errors.unitImage && (
                    <span className="text-danger">
                      {errors.unitImage.message}
                    </span>
                  )}
                </Form.Group> */}

                <Form.Group className="col-6 mb-6 app-status app-status-active">
                  {/* <Form.Label>
                    Status <span className="text-danger">*</span>
                  </Form.Label> */}
                  <Form.Check
                    type="checkbox"
                    label="Status"
                    {...register("isActive")}
                    defaultChecked={traderUnitData?.isActive}
                  />
                </Form.Group>

                <div className="col-12 col-sm-6 mb-6">
                  <div className="up-img69 mb-3">
                    <ImagePreview
                      src={previewImageURL}
                      width="auto"
                      height="auto"
                      style={{
                        marginBottom: "15px",
                      }}
                    />
                    <div className="upload-edit">
                      <h6>
                        <span onClick={openCoverModal}>
                          <a href="#!">
                            <i className="fa fa-solid fa-arrow-up">
                              {" "}
                              Upload Image
                            </i>
                          </a>
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>

                <div className="col-12 row">
                  <div className="col-6">
                    <div className="back-bt12 back1">
                      <span
                        onClick={(e) => handleBackButton(e)}
                        className="btn btn-primary"
                      >
                        Back
                      </span>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="back-bt12 save2">
                      <button type="submit" className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            </section>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(CreateTraderUnit);
